import { EnumOption } from '../models/EnumOption';

export function compareEnums(v1: EnumOption, v2: EnumOption): boolean {
    return v1 && v2 ? v1.id === v2.id : v1 === v2;
}